import * as Yup from "yup";
import { selectOption } from "../Common";

// SCHEMA FOR DETAIL FORM
export interface IOPDDiagnosisDeatil {
  opdDiagnosisDetailId: number;
  opdDiagnosisId: number;
  displayOrder: number;
  consumerId: number;
  orgId: number;
  branchId: number;
  departmentId: number;
  specialityId: number;
  opdId: number;
  patientId: number;
  diagnosisId: number;
  diagnosisName: string;
  diagnosisTypeId: selectOption | null;
  diagnosisTypeName: string;
  isDeleted: boolean;
  mode: string;
  diagnosisSeverityLevel: {
    label: string;
    value: string;
    color: string;
    bg: string;
    bordercolor: string;
  } | null;
}

// CHEIF COMPALINT SCHEMA
export interface IOPDDiagnosis {
  opdDiagnosisId: number;
  opdId: number;
  specialityId: number;
  departmentId: number;
  patientId: number;
  opdDiagnosisDetailColl: Array<IOPDDiagnosisDeatil>;
  diagnosisTemplateId: selectOption | null;
  diagnosisTemplateName: string;
  isNoteEnabled: boolean;
  note: string;
  isDeleted: boolean;
  mode: string;
}

//SCHEMA VALIDATION
export const validationSchema = Yup.object().shape({
  opdDiagnosisId: Yup.number().required(),
  opdId: Yup.number().required(),
  patientId: Yup.number().required(),
  specialityId: Yup.number().required(),
  departmentId: Yup.number().required(),
  opdDiagnosisDetailColl: Yup.array()
    .of(
      Yup.object()
        .shape({
          opdDiagnosisDetailId: Yup.number().required(),
          displayOrder: Yup.number().required(),
          consumerId: Yup.number().required(),
          orgId: Yup.number().required(),
          branchId: Yup.number().required(),
          departmentId: Yup.number().required(),
          specialityId: Yup.number().required(),
          opdId: Yup.number().required(),
          diagnosisId: Yup.number().required(),
          diagnosisName: Yup.string().required(),
          // diagnosisTypeId: Yup.number().required(),
          // diagnosisTypeName: Yup.string().required(),
          diagnosisTypeId: Yup.object()
            .shape({
              value: Yup.string(),
              label: Yup.string(),
            })
            .nullable(),
          diagnosisTypeFromName: Yup.string().nullable(),
          isDeleted: Yup.boolean().required(),
          mode: Yup.string().required(),
          diagnosisSeverityLevel: Yup.object()
            .shape({
              value: Yup.string(),
              label: Yup.string(),
            })
            .nullable(),
        })
        .nullable(),
    )
    .nullable(),
  diagnosisTemplateId: Yup.object()
    .shape({
      value: Yup.string(),
      label: Yup.string(),
    })
    .nullable(),
  diagnosisTemplateName: Yup.string().nullable(),
  isNoteEnabled: Yup.boolean().nullable(),
  note: Yup.string().nullable(),
  isDeleted: Yup.boolean().required(),
});

export const diagnosisOptions = [
  {
    label: "Severe",
    value: "SEVERE",
    color: "#58151c",
    bg: "#f8d7da",
    bordercolor: "#f1aeb5",
  },
  {
    label: "Moderate",
    value: "MODERATE",
    color: "#613812",
    bg: "#ffd588",
    bordercolor: "#f0ac2f",
  },
  {
    label: "Mild",
    value: "MILD",
    color: "#664d03",
    bg: "#fff3cd",
    bordercolor: "#f0d073",
  },
  {
    label: "Normal",
    value: "NORMAL",
    color: "#0a3622",
    bg: "#d1e7dd",
    bordercolor: "#a3cfbb",
  },
  {
    label: "Uncategorized",
    value: "UNCATEGORIZED",
    color: "#0009",
    bg: "#e1e1e1",
    bordercolor: "#c0c1c2",
  },
  // {
  //   label: "Information",
  //   value: "INFORMATION",
  //   color: "#055160",
  //   bg: "#cff4fc",
  //   bordercolor: "#9eeaf9",
  // },
];
